import CryptoJS from 'crypto-js';

export const generateSecret = () => {
  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  return CryptoJS.SHA256(userAgent + platform + timezone).toString();
};

export const encrypt = (text) => {
  try {
    const secret = generateSecret();
    return CryptoJS.AES.encrypt(text, secret).toString();
  } catch (error) {
    console.error('Encryption failed:', error);
    return null;
  }
};

export const decrypt = (ciphertext) => {
  try {
    const secret = generateSecret();
    const bytes = CryptoJS.AES.decrypt(ciphertext, secret);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};

export const secureStore = (key, value) => {
  const encrypted = encrypt(value);
  if (encrypted !== null) {
    localStorage.setItem(key, encrypted);
  } else {
    console.warn(`Failed to store value for key "${key}"`);
  }
};

export const secureRetrieve = (key, defaultValue = null) => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return defaultValue;
  return decrypt(encrypted);
};
